package one.healthium.decompose

import com.arkivanov.decompose.Cancellation
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.value.Value

inline fun <reified Child : Any> Value<ChildStack<*, *>>.waitForChild(crossinline block: (Child) -> Unit) {
    var cancellation: Cancellation? = null
    cancellation = subscribe { stack ->
        val active = stack.active.instance
        if (active is Child) {
            block(active)
            cancellation?.cancel()
        }
    }
}
